import React, { useState } from 'react';
import Data from '../../Data/Data.json'
import { Button, Table, Typography, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Backspace, Print } from '@mui/icons-material';
import { Box, ButtonGroup, Button as ButtonI } from '@mui/material';
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { useAuthHeader, useAuthUser } from '../../Services/Auth/sessionAuth';
import i18next from 'i18next';
import Utilisateur from '../../Models/Utilisateur';
import Logo from "../../Res/csal-logo.svg";
import ExcelIcon from '../../Res/ExcelIcon.svg';
import PageNotFound from '../../Pages/PageNotFound';
import DataHistoCpt from '../../Types/DataHistoCpt';
import ReformatNumber from '../../Functions/Traitement/ReformatNumber';
import FraisHistcpt from '../../Functions/Traitement/FraisHistcpt';

const PrintHistoCpt = () => {
    const [tab, setTab] = React.useState(localStorage.getItem(Data.LocalVariable.tabHistCpt) ? JSON.parse(localStorage.getItem(Data.LocalVariable.tabHistCpt) + "") : null as any)
    const navigate = useNavigate();
    const [DataExcel, SetDataExcel] = useState<DataHistoCpt[]>([]);


    // USER SESSION
    const auth = useAuthUser();

    // USER TOKEN
    const authHeader = useAuthHeader()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
    //loading Boutton  
    const [loading, setLoading] = useState(false);
    const _exporter = React.createRef<ExcelExport>();
    const exportExcel = () => {
        SetDataExcel([]);
        setLoading(true);

        tab?.data.map((data: any, indice: any) => {
            DataExcel.push({
                key: indice,
                DATOPE: data.DATOPE,
                TIME: data.TIME,
                DEDEVR: data.DEDEVR,
                REPECE: data.REPECE,
                NUMRAP: data.NUMRAP,
                LIBELL: data.LIBELL,
                MONTANTDEBIT: ReformatNumber(data.MONTANTDEBIT ? data.MONTANTDEBIT : ''),
                MONTANTCREDIT: ReformatNumber(data.MONTANTCREDIT ? data.MONTANTCREDIT : ''),
                SOLDT: ReformatNumber(data.SOLDT),
                NBENEF: data.NBENEF,
                UTISAI: data.UTISAI
            })
        })

        if (!_exporter.current) {
            return;
        }
        _exporter.current.save();
    };

    const handleExport = () => {
        setLoading(false);
    }

    const HandlerPrint = () => {
        FraisHistcpt(user.coduti, user.codage, authHeader, tab?.form?.NUMCPT);
        window.print();
    }

    setTimeout(() => {
        if (tab == null) {

        }
    }, 2000)

    return (
        <div><br />
            {tab ?
                <>
                    <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                        <Box className='backBtnt' zIndex={2} onClick={() => {
                            switch (tab?.P) {
                                case "H": { navigate("/transaction/historicial/" + tab?.form?.NUMCPT); break }
                                case "S": { navigate("/SituationClient/" + tab?.form?.NUMCLI); break }
                            }
                        }}><Backspace /></Box>
                        <ExcelExport filterable={true} data={DataExcel} fileName={"HistoriqueCompte"+"_"+user.codage+"_"+user.coduti+"_"+Data.LocalVariable.appName+"_"+Date.now()+".xlsx"} ref={_exporter} onExportComplete={handleExport}>
                            <ExcelExportColumn field="DATOPE" title="Date Opération" locked={true} width={200} />
                            <ExcelExportColumn field="DEDEVR" title="Date De Valeur" width={200} />
                            <ExcelExportColumn title="Reference" field="NUMRAP" />
                            <ExcelExportColumn field="LIBELL" title="Libelle" />
                            <ExcelExportColumn title="Debit" field="MONTANTDEBIT" width={200} />
                            <ExcelExportColumn title="Crédit" field="MONTANTCREDIT" width={200} />
                            <ExcelExportColumn title="Total" field="SOLDT" width={200} />
                            <ExcelExportColumn title="Beneficiare" field="NBENEF" />
                        </ExcelExport>
                        <Box marginLeft={'1%'} className={"preview_print"}>
                            <Box className={"title"} display={"flex"} fontStyle={"inherit"}>
                                <img className='printLogo' src={Logo} width={80} />
                                <Typography style={{ textAlign: 'center', marginLeft: '35%' }} className='textTitle'><b>HISTORIQUE DE COMPTE </b></Typography >
                                <hr className='hide' />
                                <Box  display={'flex'} gap={'1em'}  marginLeft={'30%'}>
                                    <Button title='Imprimer ( ctrl + p )' onClick={() => { window.print() }} icon={<Print />} size='large' className='bt_add' type="ghost" htmlType="button" block  ></Button>
                                    <ButtonGroup  disableElevation color='success'  variant="outlined" aria-label="Disabled elevation buttons">
                                     <ButtonI  id='ExelExport' onClick={exportExcel} disabled={tab.data.length >= 1 ? false : true}> <img style={{ width: '50%',padding:0,margin:0 }}  className='ExelExport' onClick={exportExcel} src={ExcelIcon}></img> </ButtonI>
                                    </ButtonGroup>
                                </Box>
                            </Box><br />
                            <Box display={"flex"} fontStyle="inherit">
                                <Box width={"50%"} >
                                    <Box width={"120%"} display={"flex"}><Typography>Agence : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{user.codage}</b> {user.agence}</Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Client : </Typography><Typography style={{ marginLeft: '4%' }} ><b>{tab?.form?.NUMCLI} </b> {tab?.form?.lib_NUMCLI}</Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Compte : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{tab?.form?.NUMCPT} </b>{tab?.form?.lib_NUMCPT}</Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Adresse : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{tab?.form?.NumDomCli} </b></Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Boite Postale : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{tab?.form?.adrPostal} </b></Typography></Box>
                                    <hr />
                                </Box>
                                <Box width={"30%"} marginTop={'-1%'}>
                                    <Typography style={{ textAlign: 'center' }} > <b>{"Période Allant Du " + (new Date(tab?.form?.datD)).toLocaleDateString("fr") + " Au " + " " + (new Date(tab?.form?.DatF)).toLocaleDateString("fr")}</b> </Typography>
                                </Box>
                                <Box style={{ marginLeft: '5%' }} width={"50%"}>
                                    <Box className='haut' width={"120%"} display={"flex"}><Typography >{"Imprimé par " + user.codage + " - " + user.nomuti + " le " + (new Date(Date.now())).toLocaleDateString(i18next.language) + " à " + (new Date(Date.now())).toLocaleTimeString(i18next.language)}</Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Solde Disponible :</Typography> <Typography className='textRight'><b>{tab?.Dispon + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : ""} </b></Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Blocage :</Typography> <Typography className='textRight'><b>{tab?.form?.BLOQUE + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : ""}  </b></Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Autorisation/facilté :</Typography> <Typography className='textRight'><b>{tab?.form?.AUTORI + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : ""}  </b></Typography></Box>
                                </Box>
                            </Box>
                            <Table size='small' showHeader bordered={true} pagination={false} columns={tab?.columns} dataSource={tab.data} />
                            <Box display={"flex"} sx={{ marginLeft: '35%' }} gap={5} >
                                <Typography > <b>Total  / Nombre Débit : </b> <b>{tab?.form?.TotalDebit + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : " "}  </b> / {tab?.form?.Nbrdebit}  </Typography>
                                <Typography > <b>Total  / Nombre Crédit : </b> <b>{tab?.form?.TotalCrebit + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : " "}</b> / {tab?.form?.NbrCrebit}</Typography>
                            </Box  >
                            <Box sx={{ marginLeft: '35%' }}>
                                <Typography  > <b>Solde de Fermeture du compte au {tab?.form?.lastop} : {tab.data[tab.data.length - 1].SOLDT + " "}{tab.form.CDDEVS ? tab.form.CDDEVS : ""}</b></Typography>
                            </Box>
                        </Box>
                    </Spin>
                </>
                :
                <PageNotFound message={"Nothing to print"} backLink={"/"} texttButton={"Back to situation client"} />}
        </div >
    );
};

export default PrintHistoCpt;